module.exports = __webpack_public_path__ + "media/images/white-arrow-left-e230ee080b1056bb18a565379644f266.svg";